import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import Semantiq from 'src/scenes/Semantiq/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const semantiqRouteObject = inferRouteObject({
  path: 'semantiq',
  element: <PrivateRoute roles={Roles.SEMANTIQ} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: Semantiq.Helmet,
      children: [
        {
          Component: Semantiq.Layout,
          children: [
            { index, element: <Navigate to='./custom-audiences' replace /> },
            { path: 'dashboard', Component: Semantiq.Dashboard },
            {
              path: 'custom-audiences',
              children: [
                { index, Component: Semantiq.CustomAudiences },
                {
                  path: 'config',
                  children: [
                    { index, Component: Semantiq.CustomAudiencesConfig },
                    { path: ':configId', Component: Semantiq.CustomAudiencesConfig },
                    { path: ':configId/history', Component: Semantiq.CustomAudiencesConfigHistory },
                  ],
                },
              ],
            },
            {
              path: 'iab-audiences',
              Component: Semantiq.IABAudiences,
            },
            {
              path: 'domains',
              Component: Semantiq.Domains,
            },
          ],
        },
      ],
    },
  ],
});
